import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import IconQuote from 'components/icons/iconQuote';

const CustomerQuote = ({
  children,
  showQuoteMark = true,
  size = 'md',
  variant,
}) => (
  <p
    className={classNames(
      'text-gray relative',
      '[&_svg]:absolute [&_svg]:top-[-9px] [&_svg]:left-0 [&_svg]:z-[-1]',
      '[&_svg_path]:fill-gray-light8',
      {
        'text-sm mt-4 mx-0 mb-8': size === 'sm',
        'text-base md:text-lg mt-2 mx-0 mb-6': size === 'md',
        'max-[767px]:m-0': variant === 'InspirationPage',
      }
    )}
  >
    {showQuoteMark && <IconQuote />}
    {children}
  </p>
);

CustomerQuote.propTypes = {
  children: PropTypes.node,
  showQuoteMark: PropTypes.bool,
  size: PropTypes.oneOf(['sm', 'md']),
  variant: PropTypes.oneOf(['InspirationPage']),
};

export default CustomerQuote;
